<template>
    <div class="message-title py-2">
        <div v-if="childDependencies">
            <div class="warning-text">{{ toSentenceCase($t('planning.warnings.warning')) }}!</div>
            <div>
                {{
                    toSentenceCase(
                        $t('planning.warnings.deletingParentWarning', {
                            entity: $t(`entities.${resource}`, 1),
                        })
                    )
                }}
            </div>
            <ul>
                <li v-for="(entityIds, entity) in childDependencies" :key="entity">
                    {{ toSentenceCase($t(`entities.${entity}`, entityIds.length)) }}:
                    {{ entityIds.length }}
                    <span v-if="extraMessages[entity]">
                        ({{ $t(extraMessages[entity], { entity: $t(`entities.${entity}`, 2) }) }})
                    </span>
                </li>
            </ul>
            <div v-if="promotionsToMoveToParkingLot">
                {{
                    toSentenceCase(
                        $t('planning.warnings.revertingParkingLotPromotionsWarning', {
                            entity: $t(`entities.promotions`, promotionsToMoveToParkingLot),
                            count: promotionsToMoveToParkingLot,
                        })
                    )
                }}
            </div>
        </div>
        <div v-else>
            <div class="information-text">
                {{ toSentenceCase($t('planning.information.information')) }}!
            </div>
            <div>
                {{
                    toSentenceCase(
                        $t('planning.information.noAssociatedChildren', {
                            entity: $t(`entities.${resource}`, 1),
                        })
                    )
                }}
            </div>
        </div>
    </div>
</template>

<script>
import { get, cloneDeep, difference, has } from 'lodash';
import resources from '@enums/resources';

export default {
    props: {
        resource: String,
    },
    data() {
        return {
            extraMessages: {
                [resources.promotions]: 'planning.warnings.andAllChildEntities',
            },
        };
    },
    computed: {
        childDependencies() {
            const dependencies = cloneDeep(this.$store.state[this.resource].childDependencies);
            if (get(dependencies, 'promotionsToMoveToParkingLot')) {
                if (has(dependencies, 'promotions')) {
                    dependencies.promotions = difference(
                        dependencies.promotions,
                        dependencies.promotionsToMoveToParkingLot
                    );
                }
                delete dependencies.promotionsToMoveToParkingLot;
            }
            return dependencies && Object.keys(dependencies).length ? dependencies : null;
        },
        promotionsToMoveToParkingLot() {
            const dependencies = this.$store.state[this.resource].childDependencies;
            const promotionsToMoveToParkingLot = get(
                dependencies,
                'promotionsToMoveToParkingLot',
                []
            );
            return promotionsToMoveToParkingLot.length;
        },
    },
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';
.warning-text {
    color: $negative-action;
}
.information-text {
    color: $positive-action;
}
.message-title {
    font-size: 1.4rem;
}
</style>
